import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, User } from 'lucide-react';

const PostCard = ({ post }) => {
  return (
    <Link
      to={`/post/${post.slug}`}
      className="block group border-b border-border/40 pb-8 hover:-translate-y-1 transition-all duration-300"
      data-testid={`post-card-${post.slug}`}
    >
      <div className="overflow-hidden">
        <img
          src={post.featured_image}
          alt={post.title}
          className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
        />
      </div>
      <div className="mt-4">
        <span className="text-xs tracking-[0.2em] uppercase font-bold text-primary">
          {post.category}
        </span>
        <h3 className="text-2xl sm:text-3xl tracking-tight leading-snug font-bold mt-2 group-hover:text-primary transition-colors duration-300">
          {post.title}
        </h3>
        <p className="text-base leading-relaxed text-muted-foreground mt-3">
          {post.excerpt}
        </p>
        <div className="flex items-center space-x-4 mt-4 text-sm text-muted-foreground">
          <div className="flex items-center space-x-2">
            <User className="w-4 h-4" />
            <span>{post.author}</span>
          </div>
          <div className="flex items-center space-x-2">
            <Clock className="w-4 h-4" />
            <span>{post.reading_time} min read</span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default PostCard;
